import React from 'react';
import cn from 'classnames';
import style from './logo.mod.scss';

const Logo = ({ text, logos }) => {
  const classes = cn(style.logo);

  return (
    <div className={classes}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 552 145">
        <path
          fill="#78FBAF"
          d="M145.1 72.5c0 40.1-32.5 72.5-72.5 72.5C32.5 145 .1 112.5.1 72.5.1 32.4 32.6 0 72.6 0s72.5 32.5 72.5 72.5z"
        ></path>
        <path
          fill="#070606"
          d="M234.4 42.3c-8.8 0-15.5 5-15.5 12.5 0 7.2 5.7 9.8 12.9 11.1l8.9 1.5c12 2 20.3 7.4 20.3 20.5 0 13.6-11.2 21.6-25.6 21.6-13.4 0-26.2-7.7-26.9-24l9.5-.7c.6 11.8 9.1 16.5 17.5 16.5 8.8 0 15.7-4.3 15.7-13 0-7.8-5.7-10.5-12.9-11.8l-9-1.6c-12.5-2.1-20.2-8.1-20.2-19.5 0-13.2 11.5-21.3 25.3-21.3 11.7 0 24.5 6.2 26 22.6l-9.8.7c-1.1-11.1-8.6-15.1-16.2-15.1zm52 46.3V64.8h-16.9V56h16.9V40.3h9.8V56h20.7v8.8h-20.7v22.6c0 9.4 5.2 12.8 11.7 12.8 3.6 0 5.7-.8 6.5-1.2v8.9c-1 .3-4.1.9-8.3.9-11 .2-19.7-5.7-19.7-20.2zm43.9 11h14.5V64.8h-13.1V56h22.9v11.8c2.8-7.7 8.8-12.9 18-12.9 5.2 0 7.9 1.3 8.4 1.7v9.2c-1.3-.7-4.3-2.1-9.4-2.1-9.9 0-17 6.7-17 18.3v17.5h18.1v8.8h-42.4v-8.7zm90.6 0H439v8.8h-45.9v-8.8h18V64.8h-16.8V56h26.5v43.6h.1zm-4.8-68.4c3.5 0 6.2 2.8 6.2 6.3s-2.7 6.3-6.2 6.3-6.3-2.8-6.3-6.3 2.8-6.3 6.3-6.3zM451.3 56l15.4 42.4L482.1 56h10.5L472 108.4h-10.6L440.8 56h10.5zm49.2 26.2c0-15 10.4-27.3 26.3-27.3 15.7 0 25.9 12.1 24.4 29.9h-40.9c.9 9.3 6.5 16.7 16.6 16.7 7.5 0 12.8-4.2 14.9-10.4l9 .9c-2.3 10-11.1 17.4-24 17.4-15.9.1-26.3-12.2-26.3-27.2zm41.3-4.8c-1.2-8.2-5.9-14.5-15.1-14.5s-14.6 6.3-15.9 14.5h31z"
        ></path>
      </svg>
    </div>
  );
};

export default Logo;
